import React from "react";

const Block = (props) => {
  return (<>
    <p>{`Are you sure ${props?.value?.fullName} is ${props?.value?.status} `}</p>
  </>);
};
export default Block;
